import classnames from "gpages/utils/classnames"
import React from "react"
import ReactModal from "react-modal"
import * as styles from "./modal.module.scss"

if (typeof document === "object") {
  ReactModal.setAppElement(document.getElementById("___gatsby"))
}
const Modal = React.memo((props) => {
  return (
    <ReactModal
      className={classnames(styles.modal_base)}
      overlayClassName={classnames(styles.modal_overlay)}
      shouldCloseOnOverlayClick
      {...props}
    />
  )
})

Modal.displayName = "Modal"
export default Modal
